module.exports = __webpack_public_path__ + "img/more-icon.5ce21f51.svg";